<a
  (click)="redirectTag()"
  (keydown.enter)="redirectTag()"
  (keydown.space)="redirectTag()"
  class="button"
  tabindex="0"
  role="button"
  class="button"
>
  <div class="{{category.cor}} box text-center">
    <i
      class="fa {{ category.icone }}"
      aria-hidden="true"
    ></i>
  </div>
  <h3 *ngIf="category.titulo">{{ category.titulo }}</h3>
</a>
